// Empty-board guide. Mounts when the canvas has no shapes; vanishes the
// moment one lands. pointer-events: none keeps clicks pass-through so the
// user can drop a shape directly through the hint text.

interface Props {
  isHost: boolean;
}

export function EmptyBoardHint({ isHost }: Props) {
  return (
    <div
      aria-hidden
      className="
        absolute inset-0 z-[2] pointer-events-none
        flex items-center justify-center
      "
    >
      <div className="flex flex-col items-center gap-5 text-center max-w-[420px] px-6">
        <h2 className="text-20 font-medium text-fg-secondary m-0">
          A fresh canvas.
        </h2>
        <p className="text-13 text-fg-tertiary leading-[1.55] m-0">
          Press a shortcut, drop an image, or paste a screenshot to start.
        </p>
        <ShortcutRow>
          <Kbd>S</Kbd> <span>sticky</span>
          <Kbd>T</Kbd> <span>text</span>
          <Kbd>R</Kbd> <span>rectangle</span>
          <Kbd>F</Kbd> <span>frame</span>
        </ShortcutRow>
        <ShortcutRow>
          <Kbd>A</Kbd> <span>arrow</span>
          <Kbd>P</Kbd> <span>pen</span>
          <Kbd>O</Kbd> <span>ellipse</span>
          <Kbd>I</Kbd> <span>image</span>
        </ShortcutRow>
        {isHost && (
          <p className="text-12 text-fg-quaternary mt-2 m-0">
            Use the <span className="text-fg-tertiary">Share</span> panel on the right to invite a teammate.
          </p>
        )}
      </div>
    </div>
  );
}

function ShortcutRow({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-12 text-fg-tertiary">
      {children}
    </div>
  );
}

function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd
      className="
        font-mono text-11 leading-none
        inline-flex items-center justify-center
        min-w-[20px] h-[20px] px-1.5
        bg-bg-panel border border-border-default rounded-1
        text-fg-secondary
        shadow-xs
      "
    >
      {children}
    </kbd>
  );
}
